import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import Api from '../helpers/api';
import App from '../helpers/app';
import { take } from 'rxjs/operators';
import * as moment from 'moment';
import 'moment/locale/pt-br';

interface EstatisticaGeral {
  conferimentosHoje: number;
  conferimentosSemana: number;
  conferimentosMes: number;
}

interface EstatisticaMunicipio {
  conferimentosHoje: number;
  conferimentosSemana: number;
  conferimentosMes: number;
  totalHoje: number;
  totalSemana: number;
  totalMes: number;
  percentualHoje: number;
  percentualSemana: number;
  percentualMes: number;
}

interface ConferidorEstatistica {
  id_conferidor: number;
  nome_conferidor: string;
  cpf?: string;
  conferimentos_hoje: number;
  conferimentos_semana: number;
  conferimentos_mes: number;
  // Campos para compatibilidade com a tabela
  id?: number;
  nome?: string;
  hoje?: number;
  semana?: number;
  mes?: number;
}

interface Municipio {
  id: number;
  nome: string;
  uf?: string;
}

interface Conferidor {
  id: number;
  nome: string;
  login: string;
  ativo: number;
}

@Component({
  selector: 'app-relatorios-conferidores',
  templateUrl: './relatorios-conferidores.component.html',
  styleUrls: ['./relatorios-conferidores.component.scss']
})
export class RelatoriosConferidoresComponent implements OnInit {
  apiCall = this.api.new().silent();
  
  // Adicionar função Math para uso no template
  Math = Math;

  // Tabs
  activeTab = 'visao-geral';

  // Estatísticas Gerais (Base)
  estatisticasGerais: EstatisticaGeral = {
    conferimentosHoje: 0,
    conferimentosSemana: 0,
    conferimentosMes: 0
  };

  // Município
  municipios: Municipio[] = [];
  municipioSelecionado: Municipio = null;
  municipioIdSelecionado: number = null;
  municipiosLoading = false;
  municipiosOffset = 0;
  municipiosLimit = 50;
  municipiosTotal = 0;
  municipiosSearchTerm = '';
  municipiosHasMore = true;
  estatisticasMunicipio: EstatisticaMunicipio = {
    conferimentosHoje: 0,
    conferimentosSemana: 0,
    conferimentosMes: 0,
    totalHoje: 0,
    totalSemana: 0,
    totalMes: 0,
    percentualHoje: 0,
    percentualSemana: 0,
    percentualMes: 0
  };

  // Conferidores
  conferidores: Conferidor[] = [];
  conferidorBusca: string = '';
  conferidoresEstatisticas: ConferidorEstatistica[] = [];
  
  // Paginação para estatísticas de conferidores
  page = 1;
  pageSize = 7;
  totalConferidores = 0;

  // Ordenação
  currentSortColumn: string = '';
  currentSortDirection: string = 'asc';

  // Detalhes (Geral) - Filtros
  detalhesGeralMunicipioId: number = null;
  detalhesGeralDataInicio: string = '';
  detalhesGeralDataFim: string = '';
  detalhesGeralAgruparPor: string = 'dia'; // 'dia', 'semana', 'mes'
  detalhesGeralAgruparPorTemp: string = 'dia'; // Valor temporário do select, só aplicado após retorno
  
  // Detalhes (Geral) - Dados agrupados
  detalhesGeraisAgrupados: any[] = [];
  
  // Detalhes (Geral) - Estatísticas atuais (hoje)
  detalhesGeraisHoje: any = {
    situacao_em_conferencia: 0,
    situacao_pendente: 0,
    situacao_conferindo: 0,
    situacao_conferido: 0,
    total_servidores: 0,
    servidores_conferidos: 0,
    servidores_pendentes: 0,
    servidores_em_conferencia: 0,
    servidores_prontos_conferencia: 0,
    eficiencia_media_percentual: null,
    eficiencia_media_servidores_prontos: null,
    conferidores_cadastrados: 0,
    media_conferimentos_por_dia: null,
    conferimentos_por_dia_por_conferidor: null,
    conferencias_canceladas: 0,
    conferencias_com_erro: 0,
    conferencias_com_pendencia: 0,
    tempo_medio_processo: null,
    maior_tempo_processo: null,
    menor_tempo_processo: null,
    mediana_tempo_processo: null,
    tempo_medio_conferencia: null,
    maior_tempo_conferencia: null,
    menor_tempo_conferencia: null,
    mediana_tempo_conferencia: null,
    tempo_medio_pendente: null,
    maior_tempo_pendente: null,
    menor_tempo_pendente: null,
    mediana_tempo_pendente: null,
    tempo_medio_em_conferencia: null,
    maior_tempo_em_conferencia: null,
    menor_tempo_em_conferencia: null,
    mediana_tempo_em_conferencia: null,
    mediana_tempo_conferindo: null,
    total_com_tempo_pendente: 0,
    total_com_tempo_conferindo: 0
  };
  
  // Detalhes (Geral) - Tabela antiga (manter para compatibilidade)
  detalhesGerais: any[] = [];
  pageDetalhesGeral = 1;
  pageSizeDetalhesGeral = 10;
  totalDetalhesGeral = 0;

  // Detalhes (Conferidores) - Tabela simples
  detalhesConferidores: any[] = [];
  pageDetalhesConferidores = 1;
  pageSizeDetalhesConferidores = 10;
  totalDetalhesConferidores = 0;
  conferidorFiltroDetalhes: number = null;

  // Detalhes (Por Conferidor) - Filtros
  detalhesConferidorId: number = null;
  detalhesConferidorDataInicio: string = '';
  detalhesConferidorDataFim: string = '';
  detalhesConferidorAgruparPor: string = 'dia'; // 'dia', 'semana', 'mes'
  detalhesConferidorAgruparPorTemp: string = 'dia'; // Valor temporário do select, só aplicado após retorno
  
  // Detalhes (Por Conferidor) - Dados agrupados
  detalhesConferidorAgrupados: any[] = [];
  
  // Detalhes (Por Conferidor) - Estatísticas atuais (hoje)
  detalhesConferidorHoje: any = {
    situacao_em_conferencia: 0,
    situacao_pendente: 0,
    situacao_conferindo: 0,
    situacao_conferido: 0,
    total_servidores: 0,
    servidores_conferidos: 0,
    servidores_pendentes: 0,
    servidores_em_conferencia: 0,
    servidores_prontos_conferencia: 0,
    eficiencia_media_percentual: null,
    eficiencia_media_servidores_prontos: null,
    conferidores_cadastrados: 0,
    media_conferimentos_por_dia: null,
    conferimentos_por_dia_por_conferidor: null,
    conferencias_canceladas: 0,
    conferencias_com_erro: 0,
    conferencias_com_pendencia: 0,
    tempo_medio_processo: null,
    maior_tempo_processo: null,
    menor_tempo_processo: null,
    mediana_tempo_processo: null,
    tempo_medio_conferencia: null,
    maior_tempo_conferencia: null,
    menor_tempo_conferencia: null,
    mediana_tempo_conferencia: null,
    tempo_medio_pendente: null,
    maior_tempo_pendente: null,
    menor_tempo_pendente: null,
    mediana_tempo_pendente: null,
    tempo_medio_em_conferencia: null,
    maior_tempo_em_conferencia: null,
    menor_tempo_em_conferencia: null,
    mediana_tempo_em_conferencia: null,
    mediana_tempo_conferindo: null,
    total_com_tempo_pendente: 0,
    total_com_tempo_conferindo: 0
  };

  // Histórico
  historico: any[] = [];
  pageHistorico = 1;
  pageSizeHistorico = 10;
  totalHistorico = 0;
  dataInicioHistorico: string = '';
  dataFimHistorico: string = '';
  historicoMunicipioId: number = null;
  historicoConferidorId: number = null;

  // Reconciliação de conferências legadas sem matrícula
  vinculosPendentes: any[] = [];
  pageVinculosPendentes = 1;
  pageSizeVinculosPendentes = 10;
  totalVinculosPendentes = 0;
  vinculoMunicipioId: number = null;
  vinculoSituacao: string = '';
  vinculoDataInicio: string = '';
  vinculoDataFim: string = '';

  constructor(
    private spinner: NgxSpinnerService,
    private api: Api,
    private app: App,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit() {
    moment.locale('pt-br');
    await this.carregarDadosIniciais();
  }

  async carregarDadosIniciais() {
    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true,
    });

    try {
      // Carregar municípios
      await this.loadMunicipios();

      // Carregar conferidores
      await this.carregarConferidores();

      // Carregar estatísticas gerais
      await this.carregarEstatisticasGerais();

      // Carregar estatísticas de conferidores (com paginação)
      await this.carregarEstatisticasConferidores();
    } catch (error) {
      console.error('Erro ao carregar dados iniciais:', error);
    } finally {
      this.spinner.hide();
    }
  }

  async loadMunicipios(nome: string = '', append: boolean = false) {
    this.municipiosLoading = true;
    try {
      const params: any = {
        limit: this.municipiosLimit,
        offset: append ? this.municipiosOffset : 0
      };
      
      if (nome && nome.trim() !== '') {
        params.nome = nome.trim();
      }

      const response = await this.apiCall.get('municipios', params).pipe(take(1)).toPromise();
      
      let novosMunicipios: Municipio[] = [];
      if (response && response.data) {
        novosMunicipios = response.data;
        this.municipiosTotal = response.total || response.data.length;
      } else if (Array.isArray(response)) {
        novosMunicipios = response;
        this.municipiosTotal = response.length;
      }

      if (append) {
        this.municipios = [...this.municipios, ...novosMunicipios];
      } else {
        this.municipios = novosMunicipios;
        this.municipiosOffset = 0;
      }

      this.municipiosOffset += novosMunicipios.length;
      this.municipiosHasMore = novosMunicipios.length === this.municipiosLimit;
      
    } catch (error) {
      console.error('Erro ao carregar municípios:', error);
    }
    this.municipiosLoading = false;
  }

  async onMunicipioSearch(event: { term: string }) {
    this.municipiosSearchTerm = event.term || '';
    this.municipiosOffset = 0;
    
    if (event.term && event.term.length >= 2) {
      await this.loadMunicipios(event.term, false);
    } else if (!event.term || event.term.length === 0) {
      await this.loadMunicipios('', false);
    }
  }

  async onMunicipioScrollToEnd() {
    if (!this.municipiosLoading && this.municipiosHasMore) {
      await this.loadMunicipios(this.municipiosSearchTerm, true);
    }
  }

  async carregarEstatisticasGerais() {
    try {
      const hoje = moment().format('YYYY-MM-DD');
      const inicioSemana = moment().startOf('week').format('YYYY-MM-DD');
      const fimSemana = moment().endOf('week').format('YYYY-MM-DD');
      const inicioMes = moment().startOf('month').format('YYYY-MM-DD');
      const fimMes = moment().endOf('month').format('YYYY-MM-DD');

      // Buscar estatísticas agregadas para hoje
      const statsHoje = await this.apiCall
        .get(`conferidores/estatisticas-agregadas?data_inicio=${hoje}&data_fim=${hoje}`)
        .pipe(take(1))
        .toPromise();
      
      if (statsHoje && Array.isArray(statsHoje) && statsHoje.length > 0) {
        this.estatisticasGerais.conferimentosHoje = statsHoje.reduce((acc, stat) => 
          acc + (stat.conferimentos_hoje || 0), 0);
      }

      // Buscar estatísticas agregadas para a semana
      const statsSemana = await this.apiCall
        .get(`conferidores/estatisticas-agregadas?data_inicio=${inicioSemana}&data_fim=${fimSemana}`)
        .pipe(take(1))
        .toPromise();
      
      if (statsSemana && Array.isArray(statsSemana) && statsSemana.length > 0) {
        this.estatisticasGerais.conferimentosSemana = statsSemana.reduce((acc, stat) => 
          acc + (stat.conferimentos_semana || 0), 0);
      }

      // Buscar estatísticas agregadas para o mês
      const statsMes = await this.apiCall
        .get(`conferidores/estatisticas-agregadas?data_inicio=${inicioMes}&data_fim=${fimMes}`)
        .pipe(take(1))
        .toPromise();
      
      if (statsMes && Array.isArray(statsMes) && statsMes.length > 0) {
        this.estatisticasGerais.conferimentosMes = statsMes.reduce((acc, stat) => 
          acc + (stat.conferimentos_mes || 0), 0);
      }
    } catch (error) {
      console.error('Erro ao carregar estatísticas gerais:', error);
    }
  }

  async carregarEstatisticasMunicipio() {
    // Garantir que temos apenas o ID numérico
    let municipioId: number = null;
    
    if (this.municipioIdSelecionado) {
      // Se for um objeto, extrair o ID
      if (typeof this.municipioIdSelecionado === 'object' && this.municipioIdSelecionado !== null) {
        municipioId = (this.municipioIdSelecionado as any).id || null;
      } else {
        // Se já for um número, usar diretamente
        municipioId = Number(this.municipioIdSelecionado);
      }
    }

    if (!municipioId || isNaN(municipioId)) {
      this.estatisticasMunicipio = {
        conferimentosHoje: 0,
        conferimentosSemana: 0,
        conferimentosMes: 0,
        totalHoje: 0,
        totalSemana: 0,
        totalMes: 0,
        percentualHoje: 0,
        percentualSemana: 0,
        percentualMes: 0
      };
      return;
    }

    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true,
    });

    try {
      const hoje = moment().format('YYYY-MM-DD');
      const inicioSemana = moment().startOf('week').format('YYYY-MM-DD');
      const fimSemana = moment().endOf('week').format('YYYY-MM-DD');
      const inicioMes = moment().startOf('month').format('YYYY-MM-DD');
      const fimMes = moment().endOf('month').format('YYYY-MM-DD');

      // Estatísticas de hoje usando API agregada
      const statsHoje = await this.apiCall
        .get(`conferidores/estatisticas-agregadas?data_inicio=${hoje}&data_fim=${hoje}&id_cidade=${municipioId}`)
        .pipe(take(1))
        .toPromise();
      
      if (statsHoje && Array.isArray(statsHoje) && statsHoje.length > 0) {
        // Somar valores de todos os registros (pode haver múltiplos conferidores)
        const totalHoje = statsHoje.reduce((acc, stat) => 
          acc + ((stat.situacao_conferido || 0) + (stat.situacao_pendente || 0) + (stat.situacao_em_conferencia || 0)), 0);
        const conferidosHoje = statsHoje.reduce((acc, stat) => 
          acc + (stat.conferimentos_hoje || 0), 0);
        
        this.estatisticasMunicipio.conferimentosHoje = conferidosHoje;
        this.estatisticasMunicipio.totalHoje = totalHoje;
        
        if (this.estatisticasMunicipio.totalHoje > 0) {
          this.estatisticasMunicipio.percentualHoje = Math.round(
            (this.estatisticasMunicipio.conferimentosHoje / this.estatisticasMunicipio.totalHoje) * 100
          );
        }
      }

      // Estatísticas da semana usando API agregada
      const statsSemana = await this.apiCall
        .get(`conferidores/estatisticas-agregadas?data_inicio=${inicioSemana}&data_fim=${fimSemana}&id_cidade=${municipioId}`)
        .pipe(take(1))
        .toPromise();
      
      if (statsSemana && Array.isArray(statsSemana) && statsSemana.length > 0) {
        // Somar valores de todos os registros (pode haver múltiplos conferidores)
        const totalSemana = statsSemana.reduce((acc, stat) => 
          acc + ((stat.situacao_conferido || 0) + (stat.situacao_pendente || 0) + (stat.situacao_em_conferencia || 0)), 0);
        const conferidosSemana = statsSemana.reduce((acc, stat) => 
          acc + (stat.conferimentos_semana || 0), 0);
        
        this.estatisticasMunicipio.conferimentosSemana = conferidosSemana;
        this.estatisticasMunicipio.totalSemana = totalSemana;
        
        if (this.estatisticasMunicipio.totalSemana > 0) {
          this.estatisticasMunicipio.percentualSemana = Math.round(
            (this.estatisticasMunicipio.conferimentosSemana / this.estatisticasMunicipio.totalSemana) * 100
          );
        }
      }

      // Estatísticas do mês usando API agregada
      const statsMes = await this.apiCall
        .get(`conferidores/estatisticas-agregadas?data_inicio=${inicioMes}&data_fim=${fimMes}&id_cidade=${municipioId}`)
        .pipe(take(1))
        .toPromise();
      
      if (statsMes && Array.isArray(statsMes) && statsMes.length > 0) {
        // Somar valores de todos os registros (pode haver múltiplos conferidores)
        const totalMes = statsMes.reduce((acc, stat) => 
          acc + ((stat.situacao_conferido || 0) + (stat.situacao_pendente || 0) + (stat.situacao_em_conferencia || 0)), 0);
        const conferidosMes = statsMes.reduce((acc, stat) => 
          acc + (stat.conferimentos_mes || 0), 0);
        
        this.estatisticasMunicipio.conferimentosMes = conferidosMes;
        this.estatisticasMunicipio.totalMes = totalMes;
        
        if (this.estatisticasMunicipio.totalMes > 0) {
          this.estatisticasMunicipio.percentualMes = Math.round(
            (this.estatisticasMunicipio.conferimentosMes / this.estatisticasMunicipio.totalMes) * 100
          );
        }
      }
    } catch (error) {
      console.error('Erro ao carregar estatísticas do município:', error);
    } finally {
      this.spinner.hide();
      this.cdr.detectChanges(); // Forçar detecção de mudanças
    }
  }

  async carregarConferidores() {
    try {
      // Este método carrega apenas a lista de conferidores para o select/filtro
      // Não precisa de paginação aqui, apenas busca por nome
      const params: any = {
        ativo: 1,
        limit: 100 // Limite alto para buscar todos os conferidores para filtro
      };

      if (this.conferidorBusca && this.conferidorBusca.trim() !== '') {
        params.nome = this.conferidorBusca.trim();
      }

      const response = await this.apiCall
        .get('conferidores', params)
        .pipe(take(1))
        .toPromise();

      if (response && response.data) {
        this.conferidores = response.data;
      } else if (Array.isArray(response)) {
        this.conferidores = response;
      }
    } catch (error) {
      console.error('Erro ao carregar conferidores:', error);
    }
  }

  async carregarEstatisticasConferidores() {
    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true,
    });

    try {
      const params: any = {
        offset: (this.page - 1) * this.pageSize,
        limit: this.pageSize
      };

      // Adicionar filtro por nome se houver busca
      if (this.conferidorBusca && this.conferidorBusca.trim() !== '') {
        params.nome_conferidor = this.conferidorBusca.trim();
      }

      const response = await this.apiCall
        .get('conferidores/estatisticas-por-conferidor', params)
        .pipe(take(1))
        .toPromise();

      if (response && response.data) {
        // Mapear os dados da API para o formato esperado pela tabela
        this.conferidoresEstatisticas = response.data.map((stat: any) => ({
          id_conferidor: stat.id_conferidor,
          nome_conferidor: stat.nome_conferidor,
          cpf: stat.cpf || '',
          conferimentos_hoje: stat.conferimentos_hoje || 0,
          conferimentos_semana: stat.conferimentos_semana || 0,
          conferimentos_mes: stat.conferimentos_mes || 0,
          // Campos para compatibilidade com a tabela
          id: stat.id_conferidor,
          nome: stat.nome_conferidor,
          hoje: stat.conferimentos_hoje || 0,
          semana: stat.conferimentos_semana || 0,
          mes: stat.conferimentos_mes || 0
        }));
        this.totalConferidores = response.total || response.data.length;
      } else if (Array.isArray(response)) {
        this.conferidoresEstatisticas = response.map((stat: any) => ({
          id_conferidor: stat.id_conferidor,
          nome_conferidor: stat.nome_conferidor,
          cpf: stat.cpf || '',
          conferimentos_hoje: stat.conferimentos_hoje || 0,
          conferimentos_semana: stat.conferimentos_semana || 0,
          conferimentos_mes: stat.conferimentos_mes || 0,
          // Campos para compatibilidade com a tabela
          id: stat.id_conferidor,
          nome: stat.nome_conferidor,
          hoje: stat.conferimentos_hoje || 0,
          semana: stat.conferimentos_semana || 0,
          mes: stat.conferimentos_mes || 0
        }));
        this.totalConferidores = response.length;
      } else {
        this.conferidoresEstatisticas = [];
        this.totalConferidores = 0;
      }
    } catch (error) {
      console.error('Erro ao carregar estatísticas dos conferidores:', error);
      this.conferidoresEstatisticas = [];
      this.totalConferidores = 0;
    } finally {
      this.spinner.hide();
      this.cdr.detectChanges(); // Forçar detecção de mudanças
    }
  }

  async onMunicipioChange(municipioId: any) {
    // Garantir que temos apenas o ID numérico
    let id: number = null;
    
    if (municipioId) {
      // Se for um objeto, extrair o ID
      if (typeof municipioId === 'object' && municipioId !== null) {
        id = municipioId.id || null;
      } else {
        // Se já for um número, usar diretamente
        id = Number(municipioId);
      }
    }

    // Garantir que o ID seja sempre um número válido
    if (isNaN(id) || id === null || id === undefined) {
      id = null;
    }

    // Atualizar o valor do ngModel para garantir que seja sempre um número
    this.municipioIdSelecionado = id;

    if (!id) {
      this.municipioSelecionado = null;
      await this.carregarEstatisticasMunicipio();
      this.cdr.detectChanges(); // Forçar detecção de mudanças
      return;
    }

    // Buscar o município na lista atual
    const municipio = this.municipios.find(m => m.id === id);
    
    if (municipio) {
      this.municipioSelecionado = municipio;
      await this.carregarEstatisticasMunicipio();
      this.cdr.detectChanges(); // Forçar detecção de mudanças
    } else {
      // Se não encontrar na lista, definir apenas o ID e buscar estatísticas
      this.municipioSelecionado = { id: id, nome: '' };
      await this.carregarEstatisticasMunicipio();
      this.cdr.detectChanges(); // Forçar detecção de mudanças
    }
  }

  async buscarConferidor() {
    this.page = 1; // Reset para primeira página ao buscar
    await this.carregarEstatisticasConferidores();
  }

  onTabChange(event: any) {
    this.activeTab = event.nextId;
    
    if (this.activeTab === 'detalhes-geral') {
      this.carregarDetalhesGeral();
    } else if (this.activeTab === 'detalhes-conferidores') {
      this.carregarDetalhesPorConferidor();
    } else if (this.activeTab === 'historico') {
      this.carregarHistorico();
    } else if (this.activeTab === 'matriculas-pendentes') {
      this.carregarVinculosPendentes();
    }
  }

  async carregarDetalhesGeral() {
    // Inicializar datas se não estiverem definidas
    if (!this.detalhesGeralDataInicio || !this.detalhesGeralDataFim) {
      this.detalhesGeralDataInicio = moment().startOf('month').format('YYYY-MM-DD');
      this.detalhesGeralDataFim = moment().endOf('month').format('YYYY-MM-DD');
    }
    
    // Sincronizar valor temporário com o valor atual se ainda não foi definido
    if (!this.detalhesGeralAgruparPorTemp) {
      this.detalhesGeralAgruparPorTemp = this.detalhesGeralAgruparPor;
    }

    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true,
    });

    try {
      // Carregar dados agrupados por período
      await this.carregarDetalhesGeraisAgrupados();
      
      // Carregar estatísticas de hoje
      await this.carregarDetalhesGeraisHoje();
    } catch (error) {
      console.error('Erro ao carregar detalhes gerais:', error);
    } finally {
      this.spinner.hide();
      this.cdr.detectChanges();
    }
  }

  async carregarDetalhesGeraisAgrupados() {
    try {
      // Aplicar o valor temporário do select ao valor real antes de fazer a requisição
      this.detalhesGeralAgruparPor = this.detalhesGeralAgruparPorTemp;
      
      const params: any = {
        agrupar_por: this.detalhesGeralAgruparPor,
        data_inicio: this.detalhesGeralDataInicio,
        data_fim: this.detalhesGeralDataFim
      };

      if (this.detalhesGeralMunicipioId) {
        params.id_cidade = this.detalhesGeralMunicipioId;
      }

      const response = await this.apiCall
        .get('conferidores/estatisticas-agregadas-por-periodo', params)
        .pipe(take(1))
        .toPromise();

      let dadosAgrupados: any[] = [];
      if (response && Array.isArray(response)) {
        dadosAgrupados = response;
      } else if (response && response.data) {
        dadosAgrupados = response.data;
      }
      
      // Ordenar os dados em ordem crescente
      if (dadosAgrupados.length > 0) {
        dadosAgrupados.sort((a, b) => {
          if (this.detalhesGeralAgruparPor === 'dia') {
            const dataA = moment(a.periodo || a.data).valueOf();
            const dataB = moment(b.periodo || b.data).valueOf();
            return dataA - dataB;
          } else if (this.detalhesGeralAgruparPor === 'semana') {
            const ordemA = (a.ano * 100) + a.semana;
            const ordemB = (b.ano * 100) + b.semana;
            return ordemA - ordemB;
          } else if (this.detalhesGeralAgruparPor === 'mes') {
            const ordemA = (a.ano * 100) + a.mes;
            const ordemB = (b.ano * 100) + b.mes;
            return ordemA - ordemB;
          }
          return 0;
        });
      }
      
      this.detalhesGeraisAgrupados = dadosAgrupados;
    } catch (error) {
      console.error('Erro ao carregar detalhes gerais agrupados:', error);
      this.detalhesGeraisAgrupados = [];
    }
  }

  async carregarDetalhesGeraisHoje() {
    try {
      const hoje = moment().format('YYYY-MM-DD');
      const params: any = {
        data_inicio: hoje,
        data_fim: hoje
      };

      if (this.detalhesGeralMunicipioId) {
        params.id_cidade = this.detalhesGeralMunicipioId;
      }

      const response = await this.apiCall
        .get('conferidores/estatisticas-agregadas', params)
        .pipe(take(1))
        .toPromise();

      if (response && Array.isArray(response) && response.length > 0) {
        // Agregar dados de todos os registros
        const agregado = response.reduce((acc, stat) => {
          acc.situacao_em_conferencia = (acc.situacao_em_conferencia || 0) + (stat.situacao_em_conferencia || 0);
          acc.situacao_pendente = (acc.situacao_pendente || 0) + (stat.situacao_pendente || 0);
          acc.situacao_conferido = (acc.situacao_conferido || 0) + (stat.situacao_conferido || 0);
          
          // Novos campos de servidores
          acc.total_servidores = (acc.total_servidores || 0) + (stat.total_servidores || 0);
          acc.servidores_conferidos = (acc.servidores_conferidos || 0) + (stat.servidores_conferidos || 0);
          acc.servidores_pendentes = (acc.servidores_pendentes || 0) + (stat.servidores_pendentes || 0);
          acc.servidores_em_conferencia = (acc.servidores_em_conferencia || 0) + (stat.servidores_em_conferencia || 0);
          acc.servidores_prontos_conferencia = (acc.servidores_prontos_conferencia || 0) + (stat.servidores_prontos_conferencia || 0);
          
          // Conferências
          acc.conferencias_canceladas = (acc.conferencias_canceladas || 0) + (stat.conferencias_canceladas || 0);
          acc.conferencias_com_erro = (acc.conferencias_com_erro || 0) + (stat.conferencias_com_erro || 0);
          acc.conferencias_com_pendencia = (acc.conferencias_com_pendencia || 0) + (stat.conferencias_com_pendencia || 0);
          
          // Eficiência média (calcular média ponderada)
          if (stat.eficiencia_media_percentual !== null && stat.eficiencia_media_percentual !== undefined) {
            acc.eficiencia_media_percentual = (acc.eficiencia_media_percentual || 0) + stat.eficiencia_media_percentual;
            acc.eficiencia_count = (acc.eficiencia_count || 0) + 1;
          }
          
          if (stat.eficiencia_media_servidores_prontos !== null && stat.eficiencia_media_servidores_prontos !== undefined) {
            acc.eficiencia_media_servidores_prontos = (acc.eficiencia_media_servidores_prontos || 0) + stat.eficiencia_media_servidores_prontos;
            acc.eficiencia_servidores_count = (acc.eficiencia_servidores_count || 0) + 1;
          }
          
          acc.conferidores_cadastrados = Math.max(acc.conferidores_cadastrados || 0, stat.conferidores_cadastrados || 0);
          
          // Médias
          if (stat.media_conferimentos_por_dia !== null && stat.media_conferimentos_por_dia !== undefined) {
            acc.media_conferimentos_por_dia = (acc.media_conferimentos_por_dia || 0) + stat.media_conferimentos_por_dia;
            acc.media_count = (acc.media_count || 0) + 1;
          }
          
          if (stat.conferimentos_por_dia_por_conferidor !== null && stat.conferimentos_por_dia_por_conferidor !== undefined) {
            acc.conferimentos_por_dia_por_conferidor = (acc.conferimentos_por_dia_por_conferidor || 0) + stat.conferimentos_por_dia_por_conferidor;
            acc.conferimentos_por_conferidor_count = (acc.conferimentos_por_conferidor_count || 0) + 1;
          }
          
          // Tempos de Processo (Pendente → Conferido) - usar campos específicos
          if (acc.tempo_medio_processo === null && stat.tempo_medio_processo_pendente !== null) {
            acc.tempo_medio_processo = stat.tempo_medio_processo_pendente;
          }
          if (acc.maior_tempo_processo === null && stat.maior_tempo_processo_pendente !== null) {
            acc.maior_tempo_processo = stat.maior_tempo_processo_pendente;
          }
          if (acc.menor_tempo_processo === null && stat.menor_tempo_processo_pendente !== null) {
            acc.menor_tempo_processo = stat.menor_tempo_processo_pendente;
          }
          if (acc.mediana_tempo_processo === null && stat.mediana_tempo_processo_pendente !== null) {
            acc.mediana_tempo_processo = stat.mediana_tempo_processo_pendente;
          }
          
          // Tempos de Conferência (Conferindo → Conferido) - usar campos específicos
          if (acc.tempo_medio_conferencia === null && stat.tempo_medio_conferencia !== null) {
            acc.tempo_medio_conferencia = stat.tempo_medio_conferencia;
          }
          if (acc.maior_tempo_conferencia === null && stat.maior_tempo_conferencia !== null) {
            acc.maior_tempo_conferencia = stat.maior_tempo_conferencia;
          }
          if (acc.menor_tempo_conferencia === null && stat.menor_tempo_conferencia !== null) {
            acc.menor_tempo_conferencia = stat.menor_tempo_conferencia;
          }
          if (acc.mediana_tempo_conferencia === null && stat.mediana_tempo_conferencia !== null) {
            acc.mediana_tempo_conferencia = stat.mediana_tempo_conferencia;
          }
          
          // Tempos em "Pendente" - usar campos específicos
          if (acc.tempo_medio_pendente === null && stat.tempo_medio_pendente !== null) {
            acc.tempo_medio_pendente = stat.tempo_medio_pendente;
          }
          if (acc.maior_tempo_pendente === null && stat.maior_tempo_pendente !== null) {
            acc.maior_tempo_pendente = stat.maior_tempo_pendente;
          }
          if (acc.menor_tempo_pendente === null && stat.menor_tempo_pendente !== null) {
            acc.menor_tempo_pendente = stat.menor_tempo_pendente;
          }
          if (acc.mediana_tempo_pendente === null && stat.mediana_tempo_pendente !== null) {
            acc.mediana_tempo_pendente = stat.mediana_tempo_pendente;
          }
          
          // Tempos em "Conferindo" - usar campos específicos
          if (acc.tempo_medio_em_conferencia === null && stat.tempo_medio_conferindo !== null) {
            acc.tempo_medio_em_conferencia = stat.tempo_medio_conferindo;
          }
          if (acc.maior_tempo_em_conferencia === null && stat.maior_tempo_conferindo !== null) {
            acc.maior_tempo_em_conferencia = stat.maior_tempo_conferindo;
          }
          if (acc.menor_tempo_em_conferencia === null && stat.menor_tempo_conferindo !== null) {
            acc.menor_tempo_em_conferencia = stat.menor_tempo_conferindo;
          }
          if (acc.mediana_tempo_em_conferencia === null && stat.mediana_tempo_conferindo !== null) {
            acc.mediana_tempo_em_conferencia = stat.mediana_tempo_conferindo;
          }
          
          acc.total_com_tempo_pendente = (acc.total_com_tempo_pendente || 0) + (stat.total_com_tempo_pendente || 0);
          acc.total_com_tempo_conferindo = (acc.total_com_tempo_conferindo || 0) + (stat.total_com_tempo_conferindo || 0);
          
          return acc;
        }, {
          situacao_em_conferencia: 0,
          situacao_pendente: 0,
          situacao_conferindo: 0,
          situacao_conferido: 0,
          total_servidores: 0,
          servidores_conferidos: 0,
          servidores_pendentes: 0,
          servidores_em_conferencia: 0,
          servidores_prontos_conferencia: 0,
          eficiencia_media_percentual: null,
          eficiencia_media_servidores_prontos: null,
          eficiencia_count: 0,
          eficiencia_servidores_count: 0,
          conferidores_cadastrados: 0,
          media_conferimentos_por_dia: null,
          media_count: 0,
          conferimentos_por_dia_por_conferidor: null,
          conferimentos_por_conferidor_count: 0,
          conferencias_canceladas: 0,
          conferencias_com_erro: 0,
          conferencias_com_pendencia: 0,
          tempo_medio_processo: null,
          maior_tempo_processo: null,
          menor_tempo_processo: null,
          mediana_tempo_processo: null,
          tempo_medio_conferencia: null,
          maior_tempo_conferencia: null,
          menor_tempo_conferencia: null,
          mediana_tempo_conferencia: null,
          tempo_medio_pendente: null,
          maior_tempo_pendente: null,
          menor_tempo_pendente: null,
          mediana_tempo_pendente: null,
          tempo_medio_em_conferencia: null,
          maior_tempo_em_conferencia: null,
          menor_tempo_em_conferencia: null,
          mediana_tempo_em_conferencia: null,
          mediana_tempo_conferindo: null,
          total_com_tempo_pendente: 0,
          total_com_tempo_conferindo: 0
        });

        // Calcular médias
        if (agregado.eficiencia_count > 0) {
          agregado.eficiencia_media_percentual = agregado.eficiencia_media_percentual / agregado.eficiencia_count;
        } else {
          agregado.eficiencia_media_percentual = null;
        }
        delete agregado.eficiencia_count;
        
        if (agregado.eficiencia_servidores_count > 0) {
          agregado.eficiencia_media_servidores_prontos = agregado.eficiencia_media_servidores_prontos / agregado.eficiencia_servidores_count;
        } else {
          agregado.eficiencia_media_servidores_prontos = null;
        }
        delete agregado.eficiencia_servidores_count;
        
        if (agregado.media_count > 0) {
          agregado.media_conferimentos_por_dia = agregado.media_conferimentos_por_dia / agregado.media_count;
        } else {
          agregado.media_conferimentos_por_dia = null;
        }
        delete agregado.media_count;
        
        if (agregado.conferimentos_por_conferidor_count > 0) {
          agregado.conferimentos_por_dia_por_conferidor = agregado.conferimentos_por_dia_por_conferidor / agregado.conferimentos_por_conferidor_count;
        } else {
          agregado.conferimentos_por_dia_por_conferidor = null;
        }
        delete agregado.conferimentos_por_conferidor_count;

        this.detalhesGeraisHoje = agregado;
      } else {
        // Resetar valores se não houver dados
        this.detalhesGeraisHoje = {
          situacao_em_conferencia: 0,
          situacao_pendente: 0,
          situacao_conferindo: 0,
          situacao_conferido: 0,
          total_servidores: 0,
          servidores_conferidos: 0,
          servidores_pendentes: 0,
          servidores_em_conferencia: 0,
          servidores_prontos_conferencia: 0,
          eficiencia_media_percentual: null,
          eficiencia_media_servidores_prontos: null,
          conferidores_cadastrados: 0,
          media_conferimentos_por_dia: null,
          conferimentos_por_dia_por_conferidor: null,
          conferencias_canceladas: 0,
          conferencias_com_erro: 0,
          conferencias_com_pendencia: 0,
          tempo_medio_processo: null,
          maior_tempo_processo: null,
          menor_tempo_processo: null,
          mediana_tempo_processo: null,
          tempo_medio_conferencia: null,
          maior_tempo_conferencia: null,
          menor_tempo_conferencia: null,
          mediana_tempo_conferencia: null,
          tempo_medio_pendente: null,
          maior_tempo_pendente: null,
          menor_tempo_pendente: null,
          mediana_tempo_pendente: null,
          tempo_medio_em_conferencia: null,
          maior_tempo_em_conferencia: null,
          menor_tempo_em_conferencia: null,
          mediana_tempo_em_conferencia: null,
          mediana_tempo_conferindo: null,
          total_com_tempo_pendente: 0,
          total_com_tempo_conferindo: 0
        };
      }
    } catch (error) {
      console.error('Erro ao carregar detalhes gerais de hoje:', error);
    }
  }

  aplicarFiltrosDetalhesGeral() {
    this.carregarDetalhesGeral();
  }

  removerFiltrosDetalhesGeral() {
    this.detalhesGeralMunicipioId = null;
    this.detalhesGeralDataInicio = moment().startOf('month').format('YYYY-MM-DD');
    this.detalhesGeralDataFim = moment().endOf('month').format('YYYY-MM-DD');
    this.detalhesGeralAgruparPor = 'dia';
    this.detalhesGeralAgruparPorTemp = 'dia';
    this.carregarDetalhesGeral();
  }

  formatarTempo(minutos: number | null | undefined): string {
    if (minutos === null || minutos === undefined) return '?';
    if (minutos === 0) return '0min.';
    const horas = Math.floor(minutos / 60);
    const mins = Math.round(minutos % 60);
    if (horas > 0) {
      return `${horas}h ${mins}min.`;
    }
    return `${mins}min.`;
  }

  getPeriodosAgrupados(): string[] {
    if (!this.detalhesGeralDataInicio || !this.detalhesGeralDataFim) {
      return [];
    }
    
    const inicio = moment(this.detalhesGeralDataInicio);
    const fim = moment(this.detalhesGeralDataFim);
    const periodos: string[] = [];
    
    if (this.detalhesGeralAgruparPor === 'dia') {
      // Gerar todos os dias entre data_inicio e data_fim
      let dataAtual = inicio.clone();
      while (dataAtual.isSameOrBefore(fim, 'day')) {
        periodos.push(dataAtual.format('DD/MMM'));
        dataAtual.add(1, 'day');
      }
    } else if (this.detalhesGeralAgruparPor === 'semana') {
      // Criar um mapa de todas as semanas do intervalo
      const semanasMap = new Map<string, any>();
      
      // Primeiro, gerar todas as semanas do intervalo (domingo a sábado)
      let dataAtual = inicio.clone();
      // Ajustar para começar no domingo (semana começa no domingo)
      const diaSemana = dataAtual.day();
      if (diaSemana !== 0) {
        dataAtual.subtract(diaSemana, 'days'); // Voltar para o domingo
      }
      
      const fimAjustado = fim.clone();
      const diaSemanaFim = fimAjustado.day();
      if (diaSemanaFim !== 6) {
        fimAjustado.add(6 - diaSemanaFim, 'days'); // Ir para o sábado
      }
      
      while (dataAtual.isSameOrBefore(fimAjustado, 'day')) {
        const ano = dataAtual.year();
        const semana = dataAtual.week();
        const chave = `${ano}-${semana}`;
        
        // Verificar se temos dados do backend para esta semana
        const dadosBackend = this.detalhesGeraisAgrupados.find(d => d.ano === ano && d.semana === semana);
        
        if (dadosBackend && dadosBackend.data_inicio_semana && dadosBackend.data_fim_semana) {
          // Usar as datas do backend
          const inicioSemana = moment(dadosBackend.data_inicio_semana);
          const fimSemana = moment(dadosBackend.data_fim_semana);
          semanasMap.set(chave, {
            semana: semana,
            ano: ano,
            inicio: inicioSemana,
            fim: fimSemana
          });
        } else {
          // Se não temos dados do backend, usar a semana calculada
          const inicioSemana = dataAtual.clone();
          const fimSemana = dataAtual.clone().add(6, 'days'); // Sábado
          semanasMap.set(chave, {
            semana: semana,
            ano: ano,
            inicio: inicioSemana,
            fim: fimSemana
          });
        }
        
        dataAtual.add(7, 'days'); // Próxima semana (domingo)
      }
      
      // Converter o mapa em array ordenado
      const semanasArray = Array.from(semanasMap.values()).sort((a, b) => {
        const ordemA = (a.ano * 100) + a.semana;
        const ordemB = (b.ano * 100) + b.semana;
        return ordemA - ordemB;
      });
      
      // Formatar períodos
      semanasArray.forEach(s => {
        periodos.push(`Sem ${s.semana} (${s.inicio.format('DD/MM')} - ${s.fim.format('DD/MM')})`);
      });
    } else if (this.detalhesGeralAgruparPor === 'mes') {
      // Gerar todos os meses entre data_inicio e data_fim
      let dataAtual = inicio.clone().startOf('month');
      const fimMes = fim.clone().endOf('month');
      
      while (dataAtual.isSameOrBefore(fimMes, 'month')) {
        periodos.push(dataAtual.format('MMM/YYYY'));
        dataAtual.add(1, 'month');
      }
    }
    
    return periodos;
  }

  getTotalServidoresHoje(): number {
    return (this.detalhesGeraisHoje.situacao_em_conferencia || 0) +
           (this.detalhesGeraisHoje.situacao_pendente || 0) +
           (this.detalhesGeraisHoje.situacao_conferido || 0);
  }

  getValorPorPeriodo(periodo: string, campo: string): any {
    const itens = this.detalhesGeraisAgrupados.filter(d => {
      if (this.detalhesGeralAgruparPor === 'dia') {
        return moment(d.periodo || d.data).format('DD/MMM') === periodo;
      } else if (this.detalhesGeralAgruparPor === 'semana') {
        // Extrair semana do período formatado "Sem 5 (01/02 - 06/02)"
        const match = periodo.match(/Sem (\d+)/);
        if (match) {
          const semana = parseInt(match[1], 10);
          // Também precisamos verificar o ano, mas como o formato não inclui, vamos usar o ano dos dados
          // ou comparar com as datas
          if (d.semana === semana) {
            // Verificar se as datas correspondem ao período
            if (d.data_inicio_semana && d.data_fim_semana) {
              const inicioSemana = moment(d.data_inicio_semana).format('DD/MM');
              const fimSemana = moment(d.data_fim_semana).format('DD/MM');
              const periodoEsperado = `Sem ${semana} (${inicioSemana} - ${fimSemana})`;
              return periodoEsperado === periodo;
            }
            return true; // Se não temos datas, aceitar apenas pela semana
          }
        }
        return false;
      } else if (this.detalhesGeralAgruparPor === 'mes') {
        // Comparar formato MMM/YYYY
        const data = moment(`${d.ano}-${String(d.mes).padStart(2, '0')}-01`);
        return data.format('MMM/YYYY') === periodo;
      }
      return d.periodo === periodo;
    });
    
    if (!itens || itens.length === 0) {
      // Retornar 0 se não encontrar o item (para mostrar zerado)
      return 0;
    }

    // Para intervalos diários, o backend pode retornar múltiplas linhas no mesmo dia
    // (ex.: por conferidor). Precisamos somar para exibir o total do período.
    return itens.reduce((acc, item) => {
      const valor = item[campo];
      return acc + (typeof valor === 'number' ? valor : 0);
    }, 0);
  }

  getNomeMunicipioSelecionado(): string {
    if (!this.detalhesGeralMunicipioId) {
      return '';
    }
    const municipio = this.municipios.find(m => m.id === this.detalhesGeralMunicipioId);
    return municipio ? municipio.nome : 'selecionado';
  }

  async carregarDetalhesConferidores() {
    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true,
    });

    try {
      const params: any = {
        limit: this.pageSizeDetalhesConferidores,
        offset: (this.pageDetalhesConferidores - 1) * this.pageSizeDetalhesConferidores
      };

      if (this.conferidorFiltroDetalhes) {
        params.id_conferidor = this.conferidorFiltroDetalhes;
      }

      const response = await this.apiCall
        .get('conferidores/estatisticas', params)
        .pipe(take(1))
        .toPromise();

      if (response && response.data) {
        this.detalhesConferidores = response.data;
        this.totalDetalhesConferidores = response.total || 0;
      } else if (Array.isArray(response)) {
        this.detalhesConferidores = response;
        this.totalDetalhesConferidores = response.length;
      }
    } catch (error) {
      console.error('Erro ao carregar detalhes dos conferidores:', error);
    } finally {
      this.spinner.hide();
    }
  }

  async carregarDetalhesPorConferidor() {
    // Inicializar datas se não estiverem definidas
    if (!this.detalhesConferidorDataInicio || !this.detalhesConferidorDataFim) {
      this.detalhesConferidorDataInicio = moment().startOf('month').format('YYYY-MM-DD');
      this.detalhesConferidorDataFim = moment().endOf('month').format('YYYY-MM-DD');
    }
    
    // Sincronizar valor temporário com o valor atual se ainda não foi definido
    if (!this.detalhesConferidorAgruparPorTemp) {
      this.detalhesConferidorAgruparPorTemp = this.detalhesConferidorAgruparPor;
    }

    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true,
    });

    try {
      // Carregar dados agrupados por período
      await this.carregarDetalhesConferidorAgrupados();
      
      // Carregar estatísticas de hoje
      await this.carregarDetalhesConferidorHoje();
    } catch (error) {
      console.error('Erro ao carregar detalhes por conferidor:', error);
    } finally {
      this.spinner.hide();
      this.cdr.detectChanges();
    }
  }

  async carregarDetalhesConferidorAgrupados() {
    try {
      // Aplicar o valor temporário do select ao valor real antes de fazer a requisição
      this.detalhesConferidorAgruparPor = this.detalhesConferidorAgruparPorTemp;
      
      const params: any = {
        agrupar_por: this.detalhesConferidorAgruparPor,
        data_inicio: this.detalhesConferidorDataInicio,
        data_fim: this.detalhesConferidorDataFim
      };

      if (this.detalhesConferidorId) {
        params.id_conferidor = this.detalhesConferidorId;
      }

      const response = await this.apiCall
        .get('conferidores/estatisticas-agregadas-por-periodo', params)
        .pipe(take(1))
        .toPromise();

      let dadosAgrupados: any[] = [];
      if (response && Array.isArray(response)) {
        dadosAgrupados = response;
      } else if (response && response.data) {
        dadosAgrupados = response.data;
      }
      
      // Ordenar os dados em ordem crescente
      if (dadosAgrupados.length > 0) {
        dadosAgrupados.sort((a, b) => {
          if (this.detalhesConferidorAgruparPor === 'dia') {
            const dataA = moment(a.periodo || a.data).valueOf();
            const dataB = moment(b.periodo || b.data).valueOf();
            return dataA - dataB;
          } else if (this.detalhesConferidorAgruparPor === 'semana') {
            const ordemA = (a.ano * 100) + a.semana;
            const ordemB = (b.ano * 100) + b.semana;
            return ordemA - ordemB;
          } else if (this.detalhesConferidorAgruparPor === 'mes') {
            const ordemA = (a.ano * 100) + a.mes;
            const ordemB = (b.ano * 100) + b.mes;
            return ordemA - ordemB;
          }
          return 0;
        });
      }
      
      this.detalhesConferidorAgrupados = dadosAgrupados;
    } catch (error) {
      console.error('Erro ao carregar detalhes por conferidor agrupados:', error);
      this.detalhesConferidorAgrupados = [];
    }
  }

  async carregarDetalhesConferidorHoje() {
    try {
      const hoje = moment().format('YYYY-MM-DD');
      const params: any = {
        data_inicio: hoje,
        data_fim: hoje
      };

      if (this.detalhesConferidorId) {
        params.id_conferidor = this.detalhesConferidorId;
      }

      const response = await this.apiCall
        .get('conferidores/estatisticas-agregadas', params)
        .pipe(take(1))
        .toPromise();

      if (response && Array.isArray(response) && response.length > 0) {
        // Agregar dados de todos os registros
        const agregado = response.reduce((acc, stat) => {
          acc.situacao_em_conferencia = (acc.situacao_em_conferencia || 0) + (stat.situacao_em_conferencia || 0);
          acc.situacao_pendente = (acc.situacao_pendente || 0) + (stat.situacao_pendente || 0);
          acc.situacao_conferido = (acc.situacao_conferido || 0) + (stat.situacao_conferido || 0);
          
          // Novos campos de servidores
          acc.total_servidores = (acc.total_servidores || 0) + (stat.total_servidores || 0);
          acc.servidores_conferidos = (acc.servidores_conferidos || 0) + (stat.servidores_conferidos || 0);
          acc.servidores_pendentes = (acc.servidores_pendentes || 0) + (stat.servidores_pendentes || 0);
          acc.servidores_em_conferencia = (acc.servidores_em_conferencia || 0) + (stat.servidores_em_conferencia || 0);
          acc.servidores_prontos_conferencia = (acc.servidores_prontos_conferencia || 0) + (stat.servidores_prontos_conferencia || 0);
          
          // Conferências
          acc.conferencias_canceladas = (acc.conferencias_canceladas || 0) + (stat.conferencias_canceladas || 0);
          acc.conferencias_com_erro = (acc.conferencias_com_erro || 0) + (stat.conferencias_com_erro || 0);
          acc.conferencias_com_pendencia = (acc.conferencias_com_pendencia || 0) + (stat.conferencias_com_pendencia || 0);
          
          // Eficiência média (calcular média ponderada)
          if (stat.eficiencia_media_percentual !== null && stat.eficiencia_media_percentual !== undefined) {
            acc.eficiencia_media_percentual = (acc.eficiencia_media_percentual || 0) + stat.eficiencia_media_percentual;
            acc.eficiencia_count = (acc.eficiencia_count || 0) + 1;
          }
          
          if (stat.eficiencia_media_servidores_prontos !== null && stat.eficiencia_media_servidores_prontos !== undefined) {
            acc.eficiencia_media_servidores_prontos = (acc.eficiencia_media_servidores_prontos || 0) + stat.eficiencia_media_servidores_prontos;
            acc.eficiencia_servidores_count = (acc.eficiencia_servidores_count || 0) + 1;
          }
          
          acc.conferidores_cadastrados = Math.max(acc.conferidores_cadastrados || 0, stat.conferidores_cadastrados || 0);
          
          // Médias
          if (stat.media_conferimentos_por_dia !== null && stat.media_conferimentos_por_dia !== undefined) {
            acc.media_conferimentos_por_dia = (acc.media_conferimentos_por_dia || 0) + stat.media_conferimentos_por_dia;
            acc.media_count = (acc.media_count || 0) + 1;
          }
          
          if (stat.conferimentos_por_dia_por_conferidor !== null && stat.conferimentos_por_dia_por_conferidor !== undefined) {
            acc.conferimentos_por_dia_por_conferidor = (acc.conferimentos_por_dia_por_conferidor || 0) + stat.conferimentos_por_dia_por_conferidor;
            acc.conferimentos_por_conferidor_count = (acc.conferimentos_por_conferidor_count || 0) + 1;
          }
          
          // Tempos de Processo (Pendente → Conferido) - usar campos específicos
          if (acc.tempo_medio_processo === null && stat.tempo_medio_processo_pendente !== null) {
            acc.tempo_medio_processo = stat.tempo_medio_processo_pendente;
          }
          if (acc.maior_tempo_processo === null && stat.maior_tempo_processo_pendente !== null) {
            acc.maior_tempo_processo = stat.maior_tempo_processo_pendente;
          }
          if (acc.menor_tempo_processo === null && stat.menor_tempo_processo_pendente !== null) {
            acc.menor_tempo_processo = stat.menor_tempo_processo_pendente;
          }
          if (acc.mediana_tempo_processo === null && stat.mediana_tempo_processo_pendente !== null) {
            acc.mediana_tempo_processo = stat.mediana_tempo_processo_pendente;
          }
          
          // Tempos de Conferência (Conferindo → Conferido) - usar campos específicos
          if (acc.tempo_medio_conferencia === null && stat.tempo_medio_conferencia !== null) {
            acc.tempo_medio_conferencia = stat.tempo_medio_conferencia;
          }
          if (acc.maior_tempo_conferencia === null && stat.maior_tempo_conferencia !== null) {
            acc.maior_tempo_conferencia = stat.maior_tempo_conferencia;
          }
          if (acc.menor_tempo_conferencia === null && stat.menor_tempo_conferencia !== null) {
            acc.menor_tempo_conferencia = stat.menor_tempo_conferencia;
          }
          if (acc.mediana_tempo_conferencia === null && stat.mediana_tempo_conferencia !== null) {
            acc.mediana_tempo_conferencia = stat.mediana_tempo_conferencia;
          }
          
          // Tempos em "Pendente" - usar campos específicos
          if (acc.tempo_medio_pendente === null && stat.tempo_medio_pendente !== null) {
            acc.tempo_medio_pendente = stat.tempo_medio_pendente;
          }
          if (acc.maior_tempo_pendente === null && stat.maior_tempo_pendente !== null) {
            acc.maior_tempo_pendente = stat.maior_tempo_pendente;
          }
          if (acc.menor_tempo_pendente === null && stat.menor_tempo_pendente !== null) {
            acc.menor_tempo_pendente = stat.menor_tempo_pendente;
          }
          if (acc.mediana_tempo_pendente === null && stat.mediana_tempo_pendente !== null) {
            acc.mediana_tempo_pendente = stat.mediana_tempo_pendente;
          }
          
          // Tempos em "Conferindo" - usar campos específicos
          if (acc.tempo_medio_em_conferencia === null && stat.tempo_medio_conferindo !== null) {
            acc.tempo_medio_em_conferencia = stat.tempo_medio_conferindo;
          }
          if (acc.maior_tempo_em_conferencia === null && stat.maior_tempo_conferindo !== null) {
            acc.maior_tempo_em_conferencia = stat.maior_tempo_conferindo;
          }
          if (acc.menor_tempo_em_conferencia === null && stat.menor_tempo_conferindo !== null) {
            acc.menor_tempo_em_conferencia = stat.menor_tempo_conferindo;
          }
          if (acc.mediana_tempo_em_conferencia === null && stat.mediana_tempo_conferindo !== null) {
            acc.mediana_tempo_em_conferencia = stat.mediana_tempo_conferindo;
          }
          
          acc.total_com_tempo_pendente = (acc.total_com_tempo_pendente || 0) + (stat.total_com_tempo_pendente || 0);
          acc.total_com_tempo_conferindo = (acc.total_com_tempo_conferindo || 0) + (stat.total_com_tempo_conferindo || 0);
          
          return acc;
        }, {
          situacao_em_conferencia: 0,
          situacao_pendente: 0,
          situacao_conferindo: 0,
          situacao_conferido: 0,
          total_servidores: 0,
          servidores_conferidos: 0,
          servidores_pendentes: 0,
          servidores_em_conferencia: 0,
          servidores_prontos_conferencia: 0,
          eficiencia_media_percentual: null,
          eficiencia_media_servidores_prontos: null,
          eficiencia_count: 0,
          eficiencia_servidores_count: 0,
          conferidores_cadastrados: 0,
          media_conferimentos_por_dia: null,
          media_count: 0,
          conferimentos_por_dia_por_conferidor: null,
          conferimentos_por_conferidor_count: 0,
          conferencias_canceladas: 0,
          conferencias_com_erro: 0,
          conferencias_com_pendencia: 0,
          tempo_medio_processo: null,
          maior_tempo_processo: null,
          menor_tempo_processo: null,
          mediana_tempo_processo: null,
          tempo_medio_conferencia: null,
          maior_tempo_conferencia: null,
          menor_tempo_conferencia: null,
          mediana_tempo_conferencia: null,
          tempo_medio_pendente: null,
          maior_tempo_pendente: null,
          menor_tempo_pendente: null,
          mediana_tempo_pendente: null,
          tempo_medio_em_conferencia: null,
          maior_tempo_em_conferencia: null,
          menor_tempo_em_conferencia: null,
          mediana_tempo_em_conferencia: null,
          mediana_tempo_conferindo: null,
          total_com_tempo_pendente: 0,
          total_com_tempo_conferindo: 0
        });

        // Calcular médias
        if (agregado.eficiencia_count > 0) {
          agregado.eficiencia_media_percentual = agregado.eficiencia_media_percentual / agregado.eficiencia_count;
        } else {
          agregado.eficiencia_media_percentual = null;
        }
        delete agregado.eficiencia_count;
        
        if (agregado.eficiencia_servidores_count > 0) {
          agregado.eficiencia_media_servidores_prontos = agregado.eficiencia_media_servidores_prontos / agregado.eficiencia_servidores_count;
        } else {
          agregado.eficiencia_media_servidores_prontos = null;
        }
        delete agregado.eficiencia_servidores_count;
        
        if (agregado.media_count > 0) {
          agregado.media_conferimentos_por_dia = agregado.media_conferimentos_por_dia / agregado.media_count;
        } else {
          agregado.media_conferimentos_por_dia = null;
        }
        delete agregado.media_count;
        
        if (agregado.conferimentos_por_conferidor_count > 0) {
          agregado.conferimentos_por_dia_por_conferidor = agregado.conferimentos_por_dia_por_conferidor / agregado.conferimentos_por_conferidor_count;
        } else {
          agregado.conferimentos_por_dia_por_conferidor = null;
        }
        delete agregado.conferimentos_por_conferidor_count;

        this.detalhesConferidorHoje = agregado;
      } else {
        // Resetar valores se não houver dados
        this.detalhesConferidorHoje = {
          situacao_em_conferencia: 0,
          situacao_pendente: 0,
          situacao_conferindo: 0,
          situacao_conferido: 0,
          total_servidores: 0,
          servidores_conferidos: 0,
          servidores_pendentes: 0,
          servidores_em_conferencia: 0,
          servidores_prontos_conferencia: 0,
          eficiencia_media_percentual: null,
          eficiencia_media_servidores_prontos: null,
          conferidores_cadastrados: 0,
          media_conferimentos_por_dia: null,
          conferimentos_por_dia_por_conferidor: null,
          conferencias_canceladas: 0,
          conferencias_com_erro: 0,
          conferencias_com_pendencia: 0,
          tempo_medio_processo: null,
          maior_tempo_processo: null,
          menor_tempo_processo: null,
          mediana_tempo_processo: null,
          tempo_medio_conferencia: null,
          maior_tempo_conferencia: null,
          menor_tempo_conferencia: null,
          mediana_tempo_conferencia: null,
          tempo_medio_pendente: null,
          maior_tempo_pendente: null,
          menor_tempo_pendente: null,
          mediana_tempo_pendente: null,
          tempo_medio_em_conferencia: null,
          maior_tempo_em_conferencia: null,
          menor_tempo_em_conferencia: null,
          mediana_tempo_em_conferencia: null,
          mediana_tempo_conferindo: null,
          total_com_tempo_pendente: 0,
          total_com_tempo_conferindo: 0
        };
      }
    } catch (error) {
      console.error('Erro ao carregar detalhes por conferidor de hoje:', error);
    }
  }

  aplicarFiltrosDetalhesConferidor() {
    this.carregarDetalhesPorConferidor();
  }

  removerFiltrosDetalhesConferidor() {
    this.detalhesConferidorId = null;
    this.detalhesConferidorDataInicio = moment().startOf('month').format('YYYY-MM-DD');
    this.detalhesConferidorDataFim = moment().endOf('month').format('YYYY-MM-DD');
    this.detalhesConferidorAgruparPor = 'dia';
    this.detalhesConferidorAgruparPorTemp = 'dia';
    this.carregarDetalhesPorConferidor();
  }

  getPeriodosAgrupadosConferidor(): string[] {
    if (!this.detalhesConferidorDataInicio || !this.detalhesConferidorDataFim) {
      return [];
    }
    
    const inicio = moment(this.detalhesConferidorDataInicio);
    const fim = moment(this.detalhesConferidorDataFim);
    const periodos: string[] = [];
    
    if (this.detalhesConferidorAgruparPor === 'dia') {
      // Gerar todos os dias entre data_inicio e data_fim
      let dataAtual = inicio.clone();
      while (dataAtual.isSameOrBefore(fim, 'day')) {
        periodos.push(dataAtual.format('DD/MMM'));
        dataAtual.add(1, 'day');
      }
    } else if (this.detalhesConferidorAgruparPor === 'semana') {
      // Criar um mapa de todas as semanas do intervalo
      const semanasMap = new Map<string, any>();
      
      // Primeiro, gerar todas as semanas do intervalo (domingo a sábado)
      let dataAtual = inicio.clone();
      // Ajustar para começar no domingo (semana começa no domingo)
      const diaSemana = dataAtual.day();
      if (diaSemana !== 0) {
        dataAtual.subtract(diaSemana, 'days'); // Voltar para o domingo
      }
      
      const fimAjustado = fim.clone();
      const diaSemanaFim = fimAjustado.day();
      if (diaSemanaFim !== 6) {
        fimAjustado.add(6 - diaSemanaFim, 'days'); // Ir para o sábado
      }
      
      while (dataAtual.isSameOrBefore(fimAjustado, 'day')) {
        const ano = dataAtual.year();
        const semana = dataAtual.week();
        const chave = `${ano}-${semana}`;
        
        // Verificar se temos dados do backend para esta semana
        const dadosBackend = this.detalhesConferidorAgrupados.find(d => d.ano === ano && d.semana === semana);
        
        if (dadosBackend && dadosBackend.data_inicio_semana && dadosBackend.data_fim_semana) {
          // Usar as datas do backend
          const inicioSemana = moment(dadosBackend.data_inicio_semana);
          const fimSemana = moment(dadosBackend.data_fim_semana);
          semanasMap.set(chave, {
            semana: semana,
            ano: ano,
            inicio: inicioSemana,
            fim: fimSemana
          });
        } else {
          // Se não temos dados do backend, usar a semana calculada
          const inicioSemana = dataAtual.clone();
          const fimSemana = dataAtual.clone().add(6, 'days'); // Sábado
          semanasMap.set(chave, {
            semana: semana,
            ano: ano,
            inicio: inicioSemana,
            fim: fimSemana
          });
        }
        
        dataAtual.add(7, 'days'); // Próxima semana (domingo)
      }
      
      // Converter o mapa em array ordenado
      const semanasArray = Array.from(semanasMap.values()).sort((a, b) => {
        const ordemA = (a.ano * 100) + a.semana;
        const ordemB = (b.ano * 100) + b.semana;
        return ordemA - ordemB;
      });
      
      // Formatar períodos
      semanasArray.forEach(s => {
        periodos.push(`Sem ${s.semana} (${s.inicio.format('DD/MM')} - ${s.fim.format('DD/MM')})`);
      });
    } else if (this.detalhesConferidorAgruparPor === 'mes') {
      // Gerar todos os meses entre data_inicio e data_fim
      let dataAtual = inicio.clone().startOf('month');
      const fimMes = fim.clone().endOf('month');
      
      while (dataAtual.isSameOrBefore(fimMes, 'month')) {
        periodos.push(dataAtual.format('MMM/YYYY'));
        dataAtual.add(1, 'month');
      }
    }
    
    return periodos;
  }

  getValorPorPeriodoConferidor(periodo: string, campo: string): any {
    const itens = this.detalhesConferidorAgrupados.filter(d => {
      if (this.detalhesConferidorAgruparPor === 'dia') {
        return moment(d.periodo || d.data).format('DD/MMM') === periodo;
      } else if (this.detalhesConferidorAgruparPor === 'semana') {
        // Extrair semana do período formatado "Sem 5 (01/02 - 06/02)"
        const match = periodo.match(/Sem (\d+)/);
        if (match) {
          const semana = parseInt(match[1], 10);
          if (d.semana === semana) {
            // Verificar se as datas correspondem ao período
            if (d.data_inicio_semana && d.data_fim_semana) {
              const inicioSemana = moment(d.data_inicio_semana).format('DD/MM');
              const fimSemana = moment(d.data_fim_semana).format('DD/MM');
              const periodoEsperado = `Sem ${semana} (${inicioSemana} - ${fimSemana})`;
              return periodoEsperado === periodo;
            }
            return true; // Se não temos datas, aceitar apenas pela semana
          }
        }
        return false;
      } else if (this.detalhesConferidorAgruparPor === 'mes') {
        // Comparar formato MMM/YYYY
        const data = moment(`${d.ano}-${String(d.mes).padStart(2, '0')}-01`);
        return data.format('MMM/YYYY') === periodo;
      }
      return d.periodo === periodo;
    });
    
    if (!itens || itens.length === 0) {
      // Retornar 0 se não encontrar o item (para mostrar zerado)
      return 0;
    }

    return itens.reduce((acc, item) => {
      const valor = item[campo];
      return acc + (typeof valor === 'number' ? valor : 0);
    }, 0);
  }

  getNomeConferidorSelecionado(): string {
    if (!this.detalhesConferidorId) {
      return '';
    }
    const conferidor = this.conferidores.find(c => c.id === this.detalhesConferidorId);
    return conferidor ? conferidor.nome : 'selecionado';
  }

  async carregarHistorico() {
    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true,
    });

    try {
      const params: any = {
        limit: this.pageSizeHistorico,
        offset: (this.pageHistorico - 1) * this.pageSizeHistorico
      };

      if (this.historicoConferidorId) {
        params.id_conferidor = this.historicoConferidorId;
      }

      if (this.historicoMunicipioId) {
        params.id_cidade = this.historicoMunicipioId;
      }

      if (this.dataInicioHistorico) {
        params.data_inicio = this.dataInicioHistorico;
      }

      if (this.dataFimHistorico) {
        params.data_fim = this.dataFimHistorico;
      }

      const response = await this.apiCall
        .get('conferidores/conferencias-realizadas', params)
        .pipe(take(1))
        .toPromise();

      if (response && response.data) {
        this.historico = response.data;
        this.totalHistorico = response.total || 0;
      } else if (Array.isArray(response)) {
        this.historico = response;
        this.totalHistorico = response.length;
      } else {
        this.historico = [];
        this.totalHistorico = 0;
      }
    } catch (error) {
      console.error('Erro ao carregar histórico:', error);
      this.historico = [];
      this.totalHistorico = 0;
    } finally {
      this.spinner.hide();
      this.cdr.detectChanges();
    }
  }

  async carregarVinculosPendentes() {
    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true,
    });

    try {
      const params: any = {
        limit: this.pageSizeVinculosPendentes,
        offset: (this.pageVinculosPendentes - 1) * this.pageSizeVinculosPendentes
      };

      if (this.vinculoMunicipioId) params.id_cidade = this.vinculoMunicipioId;
      if (this.vinculoSituacao) params.situacao = this.vinculoSituacao;
      if (this.vinculoDataInicio) params.data_inicio = this.vinculoDataInicio;
      if (this.vinculoDataFim) params.data_fim = this.vinculoDataFim;

      const response: any = await this.apiCall
        .get('conferidores/estatisticas/sem-matricula', params)
        .pipe(take(1))
        .toPromise();

      if (response && Array.isArray(response.data)) {
        this.vinculosPendentes = response.data;
        this.totalVinculosPendentes = Number(response.total) || 0;
      } else {
        this.vinculosPendentes = [];
        this.totalVinculosPendentes = 0;
        if (response && response.error && response.error.message) {
          await this.app.alert('Erro!', response.error.message, 'error');
        }
      }
    } catch (error) {
      console.error('Erro ao carregar vínculos pendentes:', error);
      this.vinculosPendentes = [];
      this.totalVinculosPendentes = 0;
      await this.app.alert('Erro!', 'Não foi possível carregar as conferências sem matrícula.', 'error');
    } finally {
      this.spinner.hide();
      this.cdr.detectChanges();
    }
  }

  aplicarFiltrosVinculosPendentes() {
    this.pageVinculosPendentes = 1;
    this.carregarVinculosPendentes();
  }

  removerFiltrosVinculosPendentes() {
    this.vinculoMunicipioId = null;
    this.vinculoSituacao = '';
    this.vinculoDataInicio = '';
    this.vinculoDataFim = '';
    this.pageVinculosPendentes = 1;
    this.carregarVinculosPendentes();
  }

  async selecionarMatriculaVinculo(item: any) {
    item.carregando_matriculas = true;
    try {
      const response: any = await this.apiCall
        .get(`conferidores/estatisticas/${item.id}/matriculas-candidatas`)
        .pipe(take(1))
        .toPromise();

      if (Array.isArray(response)) {
        item.matriculas_candidatas = response;
        item.editando_matricula = true;
        item.id_matricula_selecionada = response.length === 1 ? response[0].id : null;
      } else {
        const message = response && response.error && response.error.message
          ? response.error.message
          : 'Não foi possível carregar as matrículas disponíveis.';
        await this.app.alert('Erro!', message, 'error');
      }
    } catch (error) {
      console.error('Erro ao carregar matrículas candidatas:', error);
      await this.app.alert('Erro!', 'Não foi possível carregar as matrículas disponíveis.', 'error');
    } finally {
      item.carregando_matriculas = false;
      this.cdr.detectChanges();
    }
  }

  cancelarSelecaoMatricula(item: any) {
    item.editando_matricula = false;
    item.id_matricula_selecionada = null;
    item.matriculas_candidatas = [];
  }

  async vincularMatricula(item: any) {
    if (!item.id_matricula_selecionada) {
      await this.app.alert('Atenção!', 'Selecione uma matrícula para continuar.', 'warning');
      return;
    }

    const candidata = (item.matriculas_candidatas || [])
      .find(matricula => Number(matricula.id) === Number(item.id_matricula_selecionada));
    const numeroMatricula = candidata ? candidata.matricula : item.id_matricula_selecionada;
    const confirmado = await this.app.confirm(
      'Vincular matrícula',
      `Confirma a matrícula ${numeroMatricula} para ${item.nome_servidor}? O histórico relacionado também será atualizado.`,
      'Vincular',
      'Cancelar'
    );

    if (!confirmado) return;

    item.salvando_matricula = true;
    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true,
    });

    try {
      const response: any = await this.apiCall
        .put(`conferidores/estatisticas/${item.id}/matricula`, {
          id_matricula: Number(item.id_matricula_selecionada)
        })
        .pipe(take(1))
        .toPromise();

      if (response && response.success) {
        await this.app.alert('Sucesso!', response.message, 'success');
        await this.carregarVinculosPendentes();
      } else {
        const message = response && response.error && response.error.message
          ? response.error.message
          : (response && response.message) || 'Não foi possível vincular a matrícula.';
        await this.app.alert('Erro!', message, 'error');
      }
    } catch (error) {
      console.error('Erro ao vincular matrícula:', error);
      await this.app.alert('Erro!', 'Não foi possível vincular a matrícula.', 'error');
    } finally {
      item.salvando_matricula = false;
      this.spinner.hide();
      this.cdr.detectChanges();
    }
  }

  aplicarFiltrosHistorico() {
    this.pageHistorico = 1; // Resetar para primeira página
    this.carregarHistorico();
  }

  removerFiltrosHistorico() {
    this.historicoConferidorId = null;
    this.historicoMunicipioId = null;
    this.dataInicioHistorico = '';
    this.dataFimHistorico = '';
    this.pageHistorico = 1;
    this.carregarHistorico();
  }

  sortTable(column: string) {
    if (this.currentSortColumn === column) {
      this.currentSortDirection = this.currentSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSortColumn = column;
      this.currentSortDirection = 'asc';
    }

    // Ordenação local (pode ser movida para o servidor se necessário)
    this.conferidoresEstatisticas.sort((a, b) => {
      let aValue = a[column] !== undefined ? a[column] : a[`conferimentos_${column}`];
      let bValue = b[column] !== undefined ? b[column] : b[`conferimentos_${column}`];

      if (aValue === undefined || aValue === null) aValue = 0;
      if (bValue === undefined || bValue === null) bValue = 0;

      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (this.currentSortDirection === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });
    
    this.cdr.detectChanges(); // Forçar detecção de mudanças
  }

  getTotalPages(): number {
    return Math.ceil(this.totalConferidores / this.pageSize);
  }

  async changePage(page: number) {
    if (page >= 1 && page <= this.getTotalPages()) {
      this.page = page;
      await this.carregarEstatisticasConferidores();
    }
  }

  getConferidoresPaginados(): ConferidorEstatistica[] {
    // Retorna os dados já paginados do servidor
    return this.conferidoresEstatisticas;
  }

  getPagesArray(): number[] {
    const totalPages = this.getTotalPages();
    const pages: number[] = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  shouldShowPage(page: number): boolean {
    const totalPages = this.getTotalPages();
    if (totalPages <= 7) return true;
    
    if (page === 1 || page === totalPages) return true;
    if (page >= this.page - 1 && page <= this.page + 1) return true;
    if (page === 2 || page === totalPages - 1) return true;
    
    return false;
  }

  shouldShowEllipsis(index: number): boolean {
    const totalPages = this.getTotalPages();
    if (totalPages <= 7) return false;
    
    const pages = this.getPagesArray();
    if (index === 0 || index === pages.length - 1) return false;
    
    const prevPage = pages[index - 1];
    const currentPage = pages[index];
    
    return (currentPage - prevPage) > 1 && 
           (prevPage !== 1 && prevPage !== totalPages - 1) &&
           (currentPage !== 2 && currentPage !== totalPages);
  }

  // Métodos de paginação para Detalhes Geral
  anteriorDetalhesGeral() {
    if (this.pageDetalhesGeral > 1) {
      this.pageDetalhesGeral--;
      this.carregarDetalhesGeral();
    }
  }

  proximoDetalhesGeral() {
    const totalPages = Math.ceil(this.totalDetalhesGeral / this.pageSizeDetalhesGeral);
    if (this.pageDetalhesGeral < totalPages) {
      this.pageDetalhesGeral++;
      this.carregarDetalhesGeral();
    }
  }

  irParaPaginaDetalhesGeral(pagina: number) {
    this.pageDetalhesGeral = pagina;
    this.carregarDetalhesGeral();
  }

  getTotalPagesDetalhesGeral(): number {
    return Math.ceil(this.totalDetalhesGeral / this.pageSizeDetalhesGeral);
  }

  getPagesArrayDetalhesGeral(): number[] {
    const totalPages = this.getTotalPagesDetalhesGeral();
    const pages: number[] = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  // Métodos de paginação para Detalhes Conferidores
  anteriorDetalhesConferidores() {
    if (this.pageDetalhesConferidores > 1) {
      this.pageDetalhesConferidores--;
      this.carregarDetalhesConferidores();
    }
  }

  proximoDetalhesConferidores() {
    const totalPages = Math.ceil(this.totalDetalhesConferidores / this.pageSizeDetalhesConferidores);
    if (this.pageDetalhesConferidores < totalPages) {
      this.pageDetalhesConferidores++;
      this.carregarDetalhesConferidores();
    }
  }

  irParaPaginaDetalhesConferidores(pagina: number) {
    this.pageDetalhesConferidores = pagina;
    this.carregarDetalhesConferidores();
  }

  getTotalPagesDetalhesConferidores(): number {
    return Math.ceil(this.totalDetalhesConferidores / this.pageSizeDetalhesConferidores);
  }

  getPagesArrayDetalhesConferidores(): number[] {
    const totalPages = this.getTotalPagesDetalhesConferidores();
    const pages: number[] = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  // Métodos de paginação para Histórico
  anteriorHistorico() {
    if (this.pageHistorico > 1) {
      this.pageHistorico--;
      this.carregarHistorico();
    }
  }

  proximoHistorico() {
    const totalPages = Math.ceil(this.totalHistorico / this.pageSizeHistorico);
    if (this.pageHistorico < totalPages) {
      this.pageHistorico++;
      this.carregarHistorico();
    }
  }

  irParaPaginaHistorico(pagina: number) {
    this.pageHistorico = pagina;
    this.carregarHistorico();
  }

  getTotalPagesHistorico(): number {
    return Math.ceil(this.totalHistorico / this.pageSizeHistorico);
  }

  getPagesArrayHistorico(): number[] {
    const totalPages = this.getTotalPagesHistorico();
    const pages: number[] = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  anteriorVinculosPendentes() {
    if (this.pageVinculosPendentes > 1) {
      this.pageVinculosPendentes--;
      this.carregarVinculosPendentes();
    }
  }

  proximoVinculosPendentes() {
    if (this.pageVinculosPendentes < this.getTotalPagesVinculosPendentes()) {
      this.pageVinculosPendentes++;
      this.carregarVinculosPendentes();
    }
  }

  irParaPaginaVinculosPendentes(pagina: number) {
    this.pageVinculosPendentes = pagina;
    this.carregarVinculosPendentes();
  }

  getTotalPagesVinculosPendentes(): number {
    return Math.ceil(this.totalVinculosPendentes / this.pageSizeVinculosPendentes);
  }

  getPagesArrayVinculosPendentes(): number[] {
    const pages: number[] = [];
    for (let i = 1; i <= this.getTotalPagesVinculosPendentes(); i++) {
      pages.push(i);
    }
    return pages;
  }

  justificarPeriodo(wrapperId: string) {
    // Usar setTimeout para garantir que o DOM esteja atualizado
    setTimeout(() => {
      // Encontrar o wrapper que foi clicado
      const wrapperElement = document.getElementById(wrapperId);
      if (!wrapperElement) return;

      // Encontrar a tabela dentro do wrapper
      const table = wrapperElement.querySelector('table');
      if (!table) return;

      // Calcular qual período está no centro visível da tabela
      const wrapperRect = wrapperElement.getBoundingClientRect();
      const wrapperCenterX = wrapperRect.left + wrapperRect.width / 2;
      
      // Encontrar qual coluna (período) está mais próxima do centro
      const headers = table.querySelectorAll('thead th');
      let periodoIndex = 0;
      let minDistance = Infinity;

      headers.forEach((header, index) => {
        const headerRect = header.getBoundingClientRect();
        const headerCenterX = headerRect.left + headerRect.width / 2;
        const distance = Math.abs(headerCenterX - wrapperCenterX);
        
        if (distance < minDistance) {
          minDistance = distance;
          periodoIndex = index;
        }
      });

      // Obter o período correspondente
      const periodos = this.getPeriodosAgrupados();
      if (periodoIndex >= periodos.length || periodos.length === 0) return;

      const periodoAlvo = periodos[periodoIndex];

      // Rolar todas as outras tabelas para o mesmo período
      const todosWrappers = document.querySelectorAll('.analise-periodo-wrapper');
      todosWrappers.forEach((wrapper: any) => {
        if (wrapper.id === wrapperId) return; // Pular o wrapper que foi clicado
        
        const tabela = wrapper.querySelector('table');
        if (!tabela) return;

        const headers = tabela.querySelectorAll('thead th');
        const indexAlvo = Array.from(headers).findIndex((header: any) => {
          return header.textContent.trim() === periodoAlvo;
        });

        if (indexAlvo >= 0 && headers[indexAlvo]) {
          const headerAlvo = headers[indexAlvo] as HTMLElement;
          const headerRect = headerAlvo.getBoundingClientRect();
          const wrapperRect = wrapper.getBoundingClientRect();
          const scrollLeft = wrapper.scrollLeft + (headerRect.left - wrapperRect.left) - (wrapperRect.width / 2) + (headerRect.width / 2);
          
          wrapper.scrollTo({
            left: Math.max(0, scrollLeft),
            behavior: 'smooth'
          });
        }
      });
    }, 0);
  }
}
